import { render, staticRenderFns } from "./BlockListLinkListCustom.vue?vue&type=template&id=3a714d88&"
import script from "./BlockListLinkListCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListLinkListCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports